export class KvSound {
  constructor() {
    this.player = document.getElementById('musicPlayer')
    this.canvas = document.getElementById('mpCanvas')
    this.ctx = this.canvas.getContext('2d')
    this.icon = document.getElementById('mpIcon')
    this.marquee = document.getElementById('mpMarquee')

    this.audio = new Audio('sound/tsm30s_master.mp3')
    this.audio.loop = true
    this.isPlaying = false

    this.analyser = null
    this.dataArray = null
    this.animFrameId = null

    this._initAudioContext()
    this._bindEvents()
    this._resizeCanvas()
    this._drawIdle()
  }

  _initAudioContext() {
    this.audioCtx = new (window.AudioContext || window.webkitAudioContext)()
    const source = this.audioCtx.createMediaElementSource(this.audio)
    this.analyser = this.audioCtx.createAnalyser()
    this.analyser.fftSize = 2048
    this.dataArray = new Uint8Array(this.analyser.fftSize)
    source.connect(this.analyser)
    this.analyser.connect(this.audioCtx.destination)
  }

  _bindEvents() {
    this.player.addEventListener('click', () => this._toggle())
    this.player.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        this._toggle()
      }
    })
    window.addEventListener('resize', () => this._resizeCanvas())
  }

  _toggle() {
    if (this.isPlaying) {
      this._pause()
    } else {
      this._play()
    }
  }

  _play() {
    if (this.audioCtx.state === 'suspended') this.audioCtx.resume()
    this.audio.play()
    this.isPlaying = true
    this._setIcon('pause')
    // this.marquee.classList.add('music-player__marquee-text--scrolling')
    this._drawLoop()
  }

  _pause() {
    this.audio.pause()
    this.isPlaying = false
    this._setIcon('play')
    // this.marquee.classList.remove('music-player__marquee-text--scrolling')
    cancelAnimationFrame(this.animFrameId)
    this._drawIdle()
  }

  _setIcon(state) {
    if (state === 'pause') {
      this.icon.innerHTML = `
        <rect x="2" y="1" width="4" height="14" fill="white"/>
        <rect x="9" y="1" width="4" height="14" fill="white"/>
      `
    } else {
      this.icon.innerHTML = `<polygon points="3,1 13,8 3,15" fill="white"/>`
    }
  }

  _resizeCanvas() {
    this.canvas.width = this.player.offsetWidth
    this.canvas.height = this.player.offsetHeight
    if (!this.isPlaying) this._drawIdle()
  }

  _drawIdle() {
    const { ctx, canvas } = this
    const w = canvas.width
    const h = canvas.height

    ctx.clearRect(0, 0, w, h)
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(0, 0, w, h)

    const drawPoints = 120

    // メイン波形（フラット）
    ctx.beginPath()
    ctx.moveTo(0, h)
    for (let i = 0; i < drawPoints; i++) {
      const x = (i / (drawPoints - 1)) * w
      const y = h - 0.04 * h
      if (i === 0) {
        ctx.lineTo(x, y)
      } else {
        const prevX = ((i - 1) / (drawPoints - 1)) * w
        ctx.bezierCurveTo((prevX + x) / 2, y, (prevX + x) / 2, y, x, y)
      }
    }
    ctx.lineTo(w, h)
    ctx.closePath()
    ctx.fillStyle = 'rgba(90, 230, 205, 1)'
    ctx.fill()

    // サブ波形（フラット・薄め）
    ctx.beginPath()
    ctx.moveTo(0, h)
    for (let i = 0; i < drawPoints; i++) {
      const x = (i / (drawPoints - 1)) * w
      const y = h - 0.025 * h
      if (i === 0) {
        ctx.lineTo(x, y)
      } else {
        const prevX = ((i - 1) / (drawPoints - 1)) * w
        ctx.bezierCurveTo((prevX + x) / 2, y, (prevX + x) / 2, y, x, y)
      }
    }
    ctx.lineTo(w, h)
    ctx.closePath()
    ctx.fillStyle = 'rgba(90, 230, 205, 0.5)'
    ctx.fill()
  }

  _drawLoop() {
    this.animFrameId = requestAnimationFrame(() => this._drawLoop())

    const { ctx, canvas, analyser, dataArray } = this
    analyser.getByteTimeDomainData(dataArray)

    const w = canvas.width
    const h = canvas.height

    ctx.clearRect(0, 0, w, h)
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(0, 0, w, h)

    const total = dataArray.length
    const drawPoints = 120
    const step = Math.floor(total / drawPoints)

    if (!this._smoothData) {
      this._smoothData = new Float32Array(drawPoints).fill(0)
    }
    const smoothing = 0.75
    for (let i = 0; i < drawPoints; i++) {
      const raw = (dataArray[i * step] - 128) / 128
      const amp = Math.abs(raw)
      this._smoothData[i] = this._smoothData[i] * smoothing + amp * (1 - smoothing)
    }

    // メイン波形
    ctx.beginPath()
    ctx.moveTo(0, h)
    for (let i = 0; i < drawPoints; i++) {
      const x = (i / (drawPoints - 1)) * w
      const y = h - this._smoothData[i] * h * 0.9
      if (i === 0) {
        ctx.lineTo(x, y)
      } else {
        const prevX = ((i - 1) / (drawPoints - 1)) * w
        const prevY = h - this._smoothData[i - 1] * h * 0.9
        const cpX = (prevX + x) / 2
        ctx.bezierCurveTo(cpX, prevY, cpX, y, x, y)
      }
    }
    ctx.lineTo(w, h)
    ctx.closePath()
    ctx.fillStyle = 'rgba(90, 230, 205, 1)'
    ctx.fill()

    // サブ波形
    ctx.beginPath()
    ctx.moveTo(0, h)
    for (let i = 0; i < drawPoints; i++) {
      const x = (i / (drawPoints - 1)) * w
      const j = Math.max(i - 8, 0)
      const y = h - this._smoothData[j] * h * 0.65
      if (i === 0) {
        ctx.lineTo(x, y)
      } else {
        const prevX = ((i - 1) / (drawPoints - 1)) * w
        const prevJ = Math.max(i - 1 - 8, 0)
        const prevY = h - this._smoothData[prevJ] * h * 0.65
        const cpX = (prevX + x) / 2
        ctx.bezierCurveTo(cpX, prevY, cpX, y, x, y)
      }
    }
    ctx.lineTo(w, h)
    ctx.closePath()
    ctx.fillStyle = 'rgba(90, 230, 205, 0.5)'
    ctx.fill()
  }
}
